document.addEventListener('DOMContentLoaded', () => {
    const susanContainers = document.querySelectorAll('.item-window-susan');

    susanContainers.forEach(container => {
        const susanItemsContainer = container.querySelector('.susan-items-container');
        const scrollLeftBtn = container.querySelector('.susan-controls img:first-child');
        const scrollRightBtn = container.querySelector('.susan-controls img:last-child');

        if (!susanItemsContainer || !scrollLeftBtn || !scrollRightBtn) return;

        const getScrollAmount = () => {
            const item = susanItemsContainer.querySelector('.susan-item');
            if (!item) return 300;
            const style = getComputedStyle(item);
            return item.offsetWidth + parseInt(style.marginRight || 0);
        };

        scrollLeftBtn.addEventListener('click', () => {
            susanItemsContainer.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
            });
        });

        scrollRightBtn.addEventListener('click', () => {
            susanItemsContainer.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
            });
        });
    });
});